import { GRAAL_API_URL } from "../../config";
import { graalApiAxiosInstance } from "../../middlewares/useApiAuthMiddleware";

export const leadsAutoURI = `${GRAAL_API_URL}new-leads`;

export const onSearchLeadsAuto = (data) => {
  return graalApiAxiosInstance.post(`${leadsAutoURI}/chercher`, data);
};

export const onDeleteLeadAuto = (leadId) => {
  return graalApiAxiosInstance.delete(`${leadsAutoURI}/${leadId}`);
};

export const assignUserToLeadAuto = (
  leadId,
  userId,
  name,
  email,
  isForce = false,
) => {
  return graalApiAxiosInstance.patch(
    `${leadsAutoURI}/${leadId}/assigner-utilisateur`,
    {
      userId: userId || null,
      name: name || null,
      email: email || null,
      isForce,
    },
  );
};

export const getLeadAutoStatsTotal = (data) => {
  return graalApiAxiosInstance.post(`${leadsAutoURI}/statistiques/total`, data);
};

export const getLeadAutoStatsParAn = (data) => {
  return graalApiAxiosInstance.post(
    `${leadsAutoURI}/statistiques/par-an`,
    data,
  );
};

export const updateLeadAuto = (payload) => {
  return graalApiAxiosInstance.post(`${leadsAutoURI}`, payload);
};

export const finalizeLeadAuto = (leadUuid) => {
  return graalApiAxiosInstance.patch(`${leadsAutoURI}/${leadUuid}/finaliser`, {
    notifier: false,
  });
};

export const updateStatusAuto = (leadUuid, statut, raison_abandon = null) => {
  return graalApiAxiosInstance.patch(
    `${leadsAutoURI}/${leadUuid}/modifier-statut`,
    {
      statut,
      detail_abandon: raison_abandon
        ? {
            raison_abandon: raison_abandon.cancelReason,
            texte_abandon: raison_abandon.cancelText,
          }
        : null,
    },
  );
};
